import * as React from "react";

import { cn } from "@/lib/utils";
import clsx from "clsx";

export const CardRawClass = clsx("rounded-2xl border-nfPurple-700/30 border-8 ring-2 ring-nfPurple-700/70",
  "bg-gradient-to-br from-slate-900/50 to-slate-800/30  shadow-md shadow-nfPurple-300/20 shadow-blur-8",
  "relative backdrop-blur-md",
  "m-1 sm:m-4");

const Card = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ ref }
    className={ cn(
      CardRawClass,
      className
    ) }
    { ...props }
  />
))
Card.displayName = "Card"

const CardHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <h3
    ref={ ref }
    className={ cn("flex flex-col p-4 py-1.5", className) }
    { ...props }
  />
))
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ ref }
    className={ cn(
      "text-4xl font-semibold leading-none tracking-tight",
      className
    ) }
    { ...props }
  />
))
CardTitle.displayName = "CardTitle"

const CardDescription = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ ref }
    className={ cn("text-lg leading-4 text-slate-500 dark:text-slate-400", className) }
    { ...props }
  />
))
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ ref } className={ cn("p-4 pt-0", className) } { ...props } />
))
CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ ref }
    className={ cn(" p-4 pt-0 leading-4 whitespace-pre-wrap text-sm [&_>svg]:inline", className) }
    { ...props }
  />
))
CardFooter.displayName = "CardFooter"

export { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle };

